import React, { useState, useEffect } from "react";
import FaiBox from "../../../../MuiComponents/FaiBox";
import { Stack } from "@mui/material";
import FaiButton from "../../../../MuiComponents/FaiButton";
import Icon from "@mui/material/Icon";
import Strip from "../../../../components/Strip";
import FaiSelect from "../../../../MuiComponents/FaiSelect";
import FaiInput from "../../../../MuiComponents/FaiInput";
import { ProductController } from "../../../../controllers/productController";
import { Link } from "react-router-dom";

interface HeaderBarProps {
	onFilterChange: (filters: any) => void;
}

function HeaderBar({ onFilterChange }: HeaderBarProps) {
	const [productName, setProductName] = useState<string | null>(null);
	const [masterCategoryId, setMasterCategoryId] = useState<string | null>(null);
	const [productId, setProductId] = useState<string | null>(null);
	const [status, setStatus] = useState<string | null>(null);
	const [masterCategories, setMasterCategories] = useState<any[]>([]);
	const [subCategories, setSubCategories] = useState<any[]>([]);
	const [subCategoryId, setSubCategoryId] = useState<string | null>(null);
	const [loading, setLoading] = useState({
		masterCategories: false,
		subCategories: false,
	});

	useEffect(() => {
		fetchMasterCategories();
	}, []);

	useEffect(() => {
		if (masterCategoryId) {
			fetchSubCategories(masterCategoryId);
		} else {
			setSubCategories([]);
		}
	}, [masterCategoryId]);

	const fetchMasterCategories = async () => {
		setLoading((prev) => ({ ...prev, masterCategories: true }));
		try {
			const response = await ProductController.getMasterCategories();
			if (
				response?.data?.status === 200 &&
				response.data.data?.masterCategories
			) {
				const masterCategories = response.data.data.masterCategories;
				const categoryOptions = masterCategories.map((cat: any) => ({
					value: cat.id,
					label: cat.name,
				}));
				setMasterCategories(categoryOptions);
			}
		} catch (error) {
			console.error("Error fetching master categories:", error);
		} finally {
			setLoading((prev) => ({ ...prev, masterCategories: false }));
		}
	};

	const fetchSubCategories = async (categoryId: string) => {
		setLoading((prev) => ({ ...prev, subCategories: true }));
		try {
			const response = await ProductController.getCategoryByMastercategoryId(
				categoryId
			);
			if (response?.data?.status === 200 && response.data.data?.categories) {
				const subCategoryOptions = response.data.data.categories.map(
					(cat: any) => ({
						value: cat.id,
						label: cat.name,
					})
				);
				setSubCategories(subCategoryOptions);
			}
		} catch (error) {
			console.error("Error fetching sub categories:", error);
		} finally {
			setLoading((prev) => ({ ...prev, subCategories: false }));
		}
	};

	const applyFilters = () => {
		const filters: any = {};
		if (productName) filters.productName = productName;
		if (masterCategoryId) filters.masterCategoryId = masterCategoryId;
		if (subCategoryId) filters.categoryId = subCategoryId;
		if (productId) filters.productId = productId;
		if (status) filters.approvalStatus = status;
		onFilterChange(filters);
	};

	const resetFilters = () => {
		setProductName(null);
		setMasterCategoryId(null);
		setSubCategoryId(null);
		setProductId(null);
		setStatus(null);
		onFilterChange({});
	};

	const statusOptions = [
		{ value: "APPROVED", label: "Approved" },
		{ value: "PENDING", label: "Pending" },
		{ value: "REJECTED", label: "Rejected" },
	];

	return (
		<>
			<FaiBox mb={3}>
				<Strip>
					<FaiBox>
						<FaiBox
							display={"flex"}
							alignItems={"center"}
							justifyContent="space-between"
						>
							<div></div>
							<FaiBox m={"10px 10px"}>
								<Stack spacing={1} direction="row">
									{/* <FaiButton sx={{
                                        padding: "7px 12px !important",
                                        height: "34px",
                                        minHeight: 0
                                    }} variant="contained" color="error">
                                        <Icon
                                            sx={{
                                                marginRight: "5px"
                                            }}
                                        >
                                            delete_outline_outlined
                                        </Icon> Delete
                                    </FaiButton> */}
									<Link to={"/app/catalog/add-product"}>
										<FaiButton
											sx={{
												padding: "7px 12px !important",
												height: "34px",
												minHeight: 0,
											}}
											variant="contained"
											color="success"
										>
											<Icon
												sx={{
													marginRight: "5px",
												}}
											>
												add
											</Icon>{" "}
											Add Product
										</FaiButton>
									</Link>
								</Stack>
							</FaiBox>
						</FaiBox>
					</FaiBox>
				</Strip>
			</FaiBox>
			<FaiBox>
				<Strip>
					<FaiBox p={"10px 10px"}>
						<FaiBox className="flex items-center justify-between gap-2">
							<FaiBox>
								<Stack spacing={1} direction="row">
									<FaiInput
										placeholder="Search..."
										style={{ maxWidth: "200px" }}
										value={productName}
										onChange={(e) => {
											setProductName(e.target.value);
										}}
									/>
									<FaiSelect
										placeholder="Status"
										isClearable
										value={
											status
												? statusOptions.find((s) => s.value === status)
												: null
										}
										onChange={(option: any) =>
											setStatus(option ? option.value : null)
										}
										options={statusOptions}
									/>
									<FaiSelect
										placeholder="Category"
										isClearable
										value={
											masterCategoryId
												? masterCategories.find(
														(cat) => cat.value === masterCategoryId
												  )
												: null
										}
										onChange={(option: any) => {
											setMasterCategoryId(option ? option.value : null);
										}}
										options={masterCategories}
										isLoading={loading.masterCategories}
									/>
									<FaiSelect
										placeholder="Sub Category"
										isClearable
										value={
											subCategoryId
												? subCategories.find(
														(cat) => cat.value === subCategoryId
												  )
												: null
										}
										onChange={(option: any) =>
											setSubCategoryId(option ? option.value : null)
										}
										options={subCategories}
										isLoading={loading.subCategories}
										isDisabled={!masterCategoryId}
									/>
								</Stack>
							</FaiBox>
							<Stack spacing={1} direction="row">
								<FaiButton
									sx={{
										padding: "7px 12px !important",
										height: "34px",
										minHeight: 0,
									}}
									variant="contained"
									color="primary"
									onClick={applyFilters}
								>
									Apply
								</FaiButton>
								<FaiButton
									sx={{
										padding: "7px 12px !important",
										height: "34px",
										minHeight: 0,
									}}
									variant="contained"
									color="dark"
									onClick={resetFilters}
								>
									Reset
								</FaiButton>
							</Stack>
						</FaiBox>
					</FaiBox>
				</Strip>
			</FaiBox>
		</>
	);
}

export default HeaderBar;
